module.exports = __webpack_public_path__ + "img/add_subScript_icon.68917189.svg";